import { settingBot } from '@/features/setting-bot/store/setting';
import { storeFutuUserInfo } from '@/shared/store/userInfo';
import { useCallback } from 'react';

export const useRecommendStrategy = () => {
    const updateSetting = settingBot((s) => s.updateSetting);
    const selectedRecommendId = settingBot((s) => s.selectedRecommendId);
    const setSelectedRecommendId = settingBot((s) => s.setSelectedRecommendId);
    const setFutuSymbol = storeFutuUserInfo((s) => s.setFutuSymbol);

    const applyRecommendStrategy = useCallback((recom: PostRecommand_Res_List) => {
        // 선택된 추천 전략 ID 설정
        setSelectedRecommendId(recom.id_rcmd);

        // 세팅 다 적용
        setFutuSymbol(recom.id_tactic + 'USDT');

        // required 섹션 업데이트
        updateSetting('required.id_tactic', recom.id_tactic);
        updateSetting('required.id_ex', recom.id_ex);
        updateSetting('required.position_side', recom.position_side);
        updateSetting('required.leverage', recom.leverage);
        updateSetting('required.margin_mode', recom.margin_mode);
        updateSetting('required.tp_entry_initial', recom.tp_entry_initial);
        updateSetting('required.price_initial_limit', recom.price_initial_limit);
        updateSetting('required.pct_take_profit', recom.pct_take_profit);
        updateSetting('required.funds_per_asset', recom.funds_per_asset);

        // hedging 섹션 업데이트
        updateSetting('hedging.hedge_ratio', recom.hedge_ratio);
        updateSetting('hedging.hedge_usdt', recom.hedge_usdt);

        // tp 섹션 업데이트
        updateSetting('tp.tp_setting', recom.tp_setting);
        updateSetting('tp.simple_setting.cnt_entry', recom.simple_setting.cnt_entry);
        updateSetting('tp.simple_setting.rate_extra_entry', recom.simple_setting.rate_extra_entry);
        updateSetting('tp.simple_setting.gab_extra_entry', recom.simple_setting.gab_extra_entry);

        // detail_setting 배열 업데이트
        if (recom.tp_setting === 'detail' && recom.detail_setting) {
            const { setDetailSetting } = settingBot.getState();
            setDetailSetting(recom.detail_setting);
        }

        // option 섹션 업데이트
        updateSetting('option.pct_stop_loss', recom.pct_stop_loss);
        updateSetting('option.yn_repeat', recom.yn_repeat);
        updateSetting('option.yn_stop_loss', recom.yn_stop_loss);
        updateSetting('option.tp_entry_additional', recom.tp_entry_additional);
    }, [setSelectedRecommendId, setFutuSymbol, updateSetting]);

    const handleRecommendSelect = useCallback((recom: PostRecommand_Res_List) => {
        applyRecommendStrategy(recom);
    }, [applyRecommendStrategy]);

    return {
        selectedRecommendId,
        setSelectedRecommendId,
        applyRecommendStrategy,
        handleRecommendSelect
    };
}; 